import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { teknikTokens, teknikButtons } from '../styles/teknik-tokens.js';
import { tkPrimitives } from '../styles/tk-primitives.js';
import { tkAuthCard } from '../styles/tk-auth.js';

@customElement('app-reset-password')
export class AppResetPassword extends LitElement {
  @state() password = '';
  @state() confirm = '';
  @state() loading = false;
  @state() done = false;
  @state() error = '';
  private token = '';

  connectedCallback() {
    super.connectedCallback();
    this.token = new URLSearchParams(window.location.search).get('token') || '';
    if (!this.token) this.error = 'This reset link is missing its token. Request a new one.';
  }

  async handleSubmit(e: Event) {
    e.preventDefault();
    if (this.password !== this.confirm) { this.error = "Those passwords don't match."; return; }
    if (this.password.length < 8) { this.error = 'Use at least 8 characters.'; return; }
    this.error = '';
    this.loading = true;
    try {
      const res = await fetch('/auth/teknik/reset-password', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: this.token, password: this.password }),
      });
      const data = await res.json();
      if (!res.ok) this.error = data.error || "That didn't work. The link may have expired.";
      else this.done = true;
    } catch { this.error = "Couldn't reach Teknik. Check your connection and try again."; }
    this.loading = false;
  }

  static styles = [teknikTokens, teknikButtons, tkPrimitives, tkAuthCard, css``];

  render() {
    return html`
      <main>
        <div class="card">
          <div class="eyebrow">Password reset</div>
          <h1 class="title">Choose a new password</h1>
          <p class="sub">At least 8 characters. Longer is better than complicated.</p>

          ${this.error ? html`<div class="tk-flash err" style="margin-bottom:1rem">${this.error}</div>` : ''}

          ${this.done
            ? html`<div class="tk-flash ok">
                Password updated. <a href="/login" style="color:inherit;text-decoration:underline">Sign in</a>.
              </div>`
            : html`
                <form @submit=${this.handleSubmit}>
                  <div class="field">
                    <label class="tk-label" for="pw">New password</label>
                    <input
                      id="pw" class="tk-input" type="password"
                      autocomplete="new-password" required
                      .value=${this.password}
                      @input=${(e: any) => (this.password = e.target.value)}
                    />
                  </div>
                  <div class="field">
                    <label class="tk-label" for="pw2">Confirm password</label>
                    <input
                      id="pw2" class="tk-input" type="password"
                      autocomplete="new-password" required
                      .value=${this.confirm}
                      @input=${(e: any) => (this.confirm = e.target.value)}
                    />
                  </div>
                  <button class="tk-btn primary full" type="submit" ?disabled=${this.loading || !this.token}>
                    ${this.loading ? 'Saving…' : 'Set new password'}
                  </button>
                </form>
              `}

          <div class="foot"><a href="/login">Back to sign in</a></div>
        </div>
      </main>
    `;
  }
}
